interface CrosshatchPatternProps {
  width?: number;
  height?: number;
  gap?: number;
  color?: 'primary' | 'secondary' | 'accent' | 'neutral';
  opacity?: number;
  strokeWidth?: number;
  className?: string;
}

const COLOR_MAP: Record<string, string> = {
  primary: 'var(--color-primary-500)',
  secondary: 'var(--color-secondary-500)',
  accent: '#10B981',
  neutral: '#64748b',
};

export function CrosshatchPattern({
  width = 120,
  height = 120,
  gap = 14,
  color = 'primary',
  opacity = 0.2,
  strokeWidth = 1.5,
  className = '',
}: CrosshatchPatternProps) {
  const lines: { x1: number; y1: number; x2: number; y2: number }[] = [];

  for (let offset = -height; offset < width + height; offset += gap) {
    lines.push({ x1: offset, y1: 0, x2: offset + height, y2: height });
    lines.push({ x1: offset + height, y1: 0, x2: offset, y2: height });
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      className={className}
      style={{ opacity }}
    >
      <clipPath id="crosshatch-clip">
        <rect width={width} height={height} rx={12} />
      </clipPath>
      <g clipPath="url(#crosshatch-clip)">
        {lines.map((l, i) => (
          <line
            key={i}
            x1={l.x1}
            y1={l.y1}
            x2={l.x2}
            y2={l.y2}
            stroke={COLOR_MAP[color]}
            strokeWidth={strokeWidth}
          />
        ))}
      </g>
    </svg>
  );
}
